import { defineStore } from "pinia";
import { computed, ref } from "vue";
import { getBrokerPairs } from "@/api/broker";
import { showServerError } from "@/utils";
import { BrokerPair } from "@/api/types/broker";
import store from "@/store";
import router from "@/router";
import { isRouteDeniedForRoles } from "@/mappings/role-restrictions";

const BROKER_PAIRS_KEY = 'broker_pairs';

export const useBrokerStore = defineStore('useBrokerStore', () => {
    const pairs = ref<BrokerPair[]>([]);

    const isAuthorizedRole = computed(() => {
        const brokerRoute = router?.options?.routes?.find(route => route.name === 'broker');
        const brokerPairRoute = brokerRoute?.children?.find(route => route.name === 'broker-pair');
        const brokerRouteRoles = brokerPairRoute?.meta?.roles as string[];
        const user = store.getters['authModule/GET_USER'];
        // cookie authenticated живёт дольше persisted-стора, поэтому roles
        // может не оказаться: решаем по пустому списку, а не падаем на .some
        const roles: string[] = Array.isArray(user?.roles) ? user.roles : [];
        if (isRouteDeniedForRoles('broker-pair', roles)) return false;
        return roles.some((role: string) => brokerRouteRoles.includes(role));
    });

    if (localStorage.getItem(BROKER_PAIRS_KEY)) {
        if (isAuthorizedRole.value) {
            pairs.value = JSON.parse(localStorage.getItem(BROKER_PAIRS_KEY) as string);
        } else {
            // роль могли выдать после прошлой сессии: пары закрытого раздела
            // не держим в браузере, при снятии роли они вернутся с логином
            localStorage.removeItem(BROKER_PAIRS_KEY);
        }
    }

    const getPairs = async () => {
        try {
            if (!isAuthorizedRole.value) return;
            const { data } = await getBrokerPairs();
            pairs.value = data;
            localStorage.setItem(BROKER_PAIRS_KEY, JSON.stringify(data));
        } catch (err) {
            showServerError(err, 'Список пар оффер-партнёр не загружен');
        }
    };

    return {
        pairs,
        getPairs,
    };
});
